﻿import { QueryFunction, useQuery } from '@tanstack/react-query';
import { getCategory } from '../api/CasinoApi';
import { Category } from '../apiTypes/GameService';
import { getGameData } from '../helpers/dataAdapter';
import useIsLoggedIn from '@SharedScripts/Hooks/useIsLoggedIn';
import { useEffect } from 'react';

const useSliderCategory = (categoryTitle: string, categoryId: string, sectionId: string, elementId: string) => {
  const isLoggedIn = useIsLoggedIn();
  const { isPending, isLoading, isError, data, error, refetch, isRefetching } = useQuery({
    queryKey: ['category', categoryId, isLoggedIn],
    queryFn: (() => getCategory(categoryId)) as QueryFunction<Category>,
    select: (data: Category) => data.sections?.find((section) => section.id === sectionId),
    enabled: Boolean(categoryId)
  });

  useEffect(() => {
    if (isLoggedIn) return;
    refetch();
  }, [isLoggedIn]);

  const games = getGameData(data?.games || [], isPending, elementId);

  // For testing purposes - allowing loading states between category changes
  const isPendingOrRefetching = isPending || isRefetching;

  return {
    sectionName: data?.title ?? '',
    games,
    isPendingOrRefetching,
    isError,
    isLoading,
    error
  };
};

export default useSliderCategory;
